import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'
import Caption from 'components/Luxkit/Typography/Caption'

const PaymentOption = styled.div`
  padding: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.M};
  border: 1px solid ${props => props.theme.palette.neutral.six};

  > * + * {
    margin-top: ${rem(8)};
  }
`

const PaymentOptionTitle = styled.div`
  display: flex;
  align-items: center;

  * + * {
    margin-left: ${rem(24)};
  }
`

const LearnMore = styled(TextLink)`
  margin-top: ${rem(8)};
  display: inline-block;
`

const PaymentOptionImage = styled.div``

export interface InterestFreeProduct {
  id: string;
  image: React.ReactNode;
  title: string;
  content: React.ReactNode;
  to: string;
  conditions?: string;
  brand: string;
}

interface Props {
  product: InterestFreeProduct;
  className?: string;
}

function InterestFreeOption(props: Props) {
  const { product, className } = props

  return (
    <PaymentOption className={className}>
      <PaymentOptionTitle>
        <PaymentOptionImage>{product.image}</PaymentOptionImage>
        <Heading variant="heading5">{product.brand}</Heading>
      </PaymentOptionTitle>
      <BodyText weight="bold" variant="large">{product.title}</BodyText>
      <BodyText variant="medium">{product.content}</BodyText>
      <LearnMore to={product.to}>Learn more</LearnMore>
      {product.conditions && (
        <Caption variant="large" colour="neutral-three">{product.conditions}</Caption>
      )}
    </PaymentOption>
  )
}

export default React.memo(InterestFreeOption)
